import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Company} from '../models/company';

export const companyAddActionTypes = {
  ADD: type('[Company] Add'),
  ADD_SUCCESS: type('[Company] Add Success'),
  ADD_FAIL: type('[Company] Add Fail'),
};

export class AddCompanyAction implements Action {
  readonly type = companyAddActionTypes.ADD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class AddCompanySuccessAction implements Action {
  readonly type = companyAddActionTypes.ADD_SUCCESS;
  constructor(public payload?: Company) {}
}

export class AddCompanyFailAction implements Action {
  readonly type = companyAddActionTypes.ADD_FAIL;
  constructor(public payload?: number) {}
}



